import React from "react";
const AudioCallIcon: React.FC = () => {
  return (
    <svg
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.8274 21.4998C15.9124 21.4998 14.6271 21.1689 12.7024 20.0936C10.362 18.7811 8.55165 17.5693 6.22383 15.2476C3.97946 13.0047 2.88727 11.5525 1.35868 8.7709C-0.368197 5.63028 -0.0738219 3.98403 0.255241 3.28043C0.647116 2.4395 1.22555 1.93653 1.97321 1.43731C2.39787 1.15908 2.84727 0.920567 3.31571 0.724809C3.36258 0.704653 3.40618 0.685434 3.44508 0.66809C3.67712 0.563559 4.02868 0.40559 4.47399 0.57434C4.77118 0.685903 5.03649 0.914184 5.4518 1.32434C6.30352 2.16434 7.46743 4.03512 7.8968 4.95387C8.18508 5.57309 8.37586 5.98184 8.37633 6.44028C8.37633 6.977 8.10633 7.3909 7.77868 7.83762C7.71727 7.92153 7.65633 8.00168 7.59727 8.0795C7.24055 8.54825 7.16227 8.68372 7.21383 8.92559C7.31837 9.41168 8.0979 10.8587 9.37899 12.137C10.6601 13.4153 12.0654 14.1456 12.5534 14.2497C12.8056 14.3036 12.9438 14.222 13.4276 13.8526C13.497 13.7997 13.5682 13.7448 13.6427 13.69C14.1424 13.3182 14.5371 13.0553 15.0612 13.0553H15.064C15.5201 13.0553 15.9106 13.2531 16.5574 13.5793C17.4012 14.005 19.3282 15.1539 20.1734 16.0065C20.5845 16.4209 20.8137 16.6853 20.9257 16.982C21.0945 17.4287 20.9356 17.7789 20.832 18.0132C20.8146 18.0522 20.7954 18.0948 20.7752 18.1422C20.5779 18.6098 20.338 19.0582 20.0585 19.4818C19.5602 20.2272 19.0554 20.8042 18.2126 21.1965C17.7798 21.4012 17.3062 21.5049 16.8274 21.4998Z"
        fill="#D4D6D9"
      />
    </svg>
  );
};

export default AudioCallIcon;
